import React from "react";
import { Text, View } from "react-native";
import { useNavigation } from "@react-navigation/core";
import { styles } from "./styles";
import PaymentMethods from "../../components/PaymentMethods";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";

const DepositPaymentMethod = () => {
  const navigation = useNavigation();

  function onMethodSelected(method) {
    if (method === "PIX") navigation.navigate("DepositPix");
    if (method === "Boleto") navigation.navigate("DepositBoleto");
    if (method === "CreditCard") navigation.navigate("DepositCreditCard");
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderTabs
        title={<FormattedMessage id="depositPaymentMethod.titleFormaPagt" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="depositPaymentMethod.escolhaFormaPagamento" />
          </Text>
        }
      />

      <View style={styles.container}>
        <PaymentMethods onMethodSelected={onMethodSelected} />
        <GoBackButton />
      </View>
    </View>
  );
};

export default DepositPaymentMethod;
